import { type ComponentProps } from 'react';

import { Communication, Development, General, Images, Media, Users } from '../StrokeIcons';

export type StepIconSvgType =
  | 'message'
  | 'connect'
  | 'inmail'
  | 'visit'
  | 'follow'
  | 'email'
  | 'reminder'
  | 'call'
  | 'delay'
  | 'likeRecentPosts'
  | 'wait_for_connect'
  | 'voice_note'
  | 'video_note'
  | 'sift'
  | 'switch_campaign'
  | 'switch';

/**
 * Icons that are NOT cadence step types but share this switch: the Unipile
 * action classes LinkedIn budgets per day (POS-2526), shown as counters
 * alongside the send limits.
 *
 * Kept out of {@link StepIconSvgType} on purpose — that union is consumed as a
 * cadence-step type (step pickers, block rules, step labels), and widening it
 * would make every exhaustive map over step types wrong.
 */
export type UnipileClassIconType = 'profile_fetch' | 'profile_from_search' | 'search_profile' | 'post_fetch';

export type StepIconSvgProps = ComponentProps<'svg'> & {
  iconType: StepIconSvgType | UnipileClassIconType;
};
export default function StepIconSvg({ iconType, ...props }: StepIconSvgProps) {
  switch (iconType) {
    case 'email':
      return <Communication.Mail02 {...props} />;
    case 'call':
      return <Communication.PhoneOutgoing01 {...props} />;
    case 'connect':
      return <Users.UserPlus01 {...props} />;
    case 'inmail':
      return <Communication.InMail04 {...props} />;
    case 'follow':
      return <General.Plus {...props} />;
    case 'visit':
      return <General.Eye {...props} />;
    case 'message':
      return <General.StepMessage {...props} />;
    case 'reminder':
      return <General.CheckSquareBroken {...props} />;
    case 'likeRecentPosts':
      return <General.Heart {...props} />;
    case 'voice_note':
      return <Media.Recording01 {...props} />;
    case 'video_note':
      return <Images.Camera01 {...props} />;
    case 'sift':
      return <General.FilterLines {...props} />;
    case 'switch_campaign':
      return <General.Share07 {...props} />;
    case 'switch':
      return <Development.GitBranch01 {...props} />;
    case 'profile_fetch':
      return <Users.User01 {...props} />;
    case 'profile_from_search':
      return <Users.UsersPlus {...props} />;
    case 'search_profile':
      return <General.SearchSm {...props} />;
    case 'post_fetch':
      return <General.Hash01 {...props} />;
    default:
      return null;
  }
}
